import { useState } from 'react';
import { RiAddLine } from 'react-icons/ri';

import { PageTitle, PageSubTitle } from '@lib/core/src/styledComponents/StyledComponents';
import { Stack } from '@mui/material';

import { useAnalytics } from '@/analytics/useAnalytics';
import AiWorkflow from '@/components/AiWorkflow/AiWorkflow';
import { LocalCapabilityType } from '@/components/AiWorkflow/formSchema';
import PageContainer from '@/pages/PageContainer';
import { useGoogleDriveActions } from '@/store/googleDriveStore';

import {
  CapabilitiesWrapper,
  CreateAgentButton,
  GapWrapper,
  Row
} from './JamiesCapabilitiesStyles';
import FeaturedTemplates from './components/FeaturedTemplates';
import MyCapabilities from './components/MyCapabilities';

const JamiesCapabilities = () => {
  const [isWorkflowOpen, setIsWorkflowOpen] = useState(false);
  const [editWorkflow, setEditWorkflow] = useState<LocalCapabilityType | null>(null);
  const { captureEvent } = useAnalytics();
  const { clearSelectedGoogleDriveFiles } = useGoogleDriveActions();
  const handleCreateAgent = () => {
    captureEvent('agent_capabilities.create_clicked');
    setIsWorkflowOpen(true);
  };

  const onCloseWorkflow = () => {
    setIsWorkflowOpen(false);
    clearSelectedGoogleDriveFiles();
    setEditWorkflow(null);
  };

  return (
    <PageContainer isBackButtonVisible={false}>
      <GapWrapper>
        <Row>
          <Stack>
            <PageTitle>Jamie's Capabilities</PageTitle>
            <PageSubTitle>Create, manage and deploy your AI agents.</PageSubTitle>
          </Stack>
          <CreateAgentButton startIcon={<RiAddLine size={15} />} onClick={handleCreateAgent}>
            Create new capability
          </CreateAgentButton>
        </Row>
        <CapabilitiesWrapper>
          <FeaturedTemplates
            setEditWorkflow={setEditWorkflow}
            setIsWorkflowOpen={setIsWorkflowOpen}
          />
          <MyCapabilities setEditWorkflow={setEditWorkflow} setIsWorkflowOpen={setIsWorkflowOpen} />
        </CapabilitiesWrapper>
      </GapWrapper>
      {isWorkflowOpen && (
        <AiWorkflow
          onClose={onCloseWorkflow}
          editWorkflow={editWorkflow}
          setEditWorkflow={setEditWorkflow}
        />
      )}
    </PageContainer>
  );
};

export default JamiesCapabilities;
